import { FormQuestionOption } from '@models/membership/Form'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { MEMBERSHIP_FORM_QUESTION_OPTIONS_URL } from '@utils/urls'

const fetchFormQuestionOptions = (params: TableParams) =>
  SBAPI.FetchPaginated<FormQuestionOption[]>(
    MEMBERSHIP_FORM_QUESTION_OPTIONS_URL,
    params
  )

const createFormQuestionOption = (data: FormData) =>
  SBAPI.Post(MEMBERSHIP_FORM_QUESTION_OPTIONS_URL, data)

const updateFormQuestionOption = (data: FormData) =>
  SBAPI.Post(`${MEMBERSHIP_FORM_QUESTION_OPTIONS_URL}/${data.get('id')}`, data)

const deleteFormQuestionOption = (id: number) =>
  SBAPI.Delete(`${MEMBERSHIP_FORM_QUESTION_OPTIONS_URL}/${id}`)

export {
  createFormQuestionOption,
  deleteFormQuestionOption,
  fetchFormQuestionOptions,
  updateFormQuestionOption,
}
